import {
    ChangeDetectionStrategy,
    Component,
    ElementRef,
    Input,
    ViewChild,
    OnInit,
} from '@angular/core';
import { BazisMapService } from '@bazis/map/services/map.service';
import { fromGeoJson } from '@bazis/map/services/map-utils';
import * as L from 'leaflet';

@Component({
    selector: 'app-static-map',
    templateUrl: 'static-map.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [BazisMapService],
    standalone: false
})
export class StaticMapComponent implements OnInit {
    @Input()
    tile;

    @Input()
    tileMode: 'default' | 'grey' = 'default';

    @Input()
    zoom = 7;

    @Input()
    geometry;

    @Input()
    icon;

    @ViewChild('mapElement', { static: true }) mapElement: ElementRef;

    constructor(public mapService: BazisMapService) {}

    ngOnInit() {
        if (!this.geometry) return;
        this.mapService.initMap(this.mapElement.nativeElement, {
            tile: this.tile,
            defaultLocation: L.latLng(fromGeoJson(this.geometry) as L.LatLngTuple),
            additionalSettings: {
                doubleClickZoom: false,
                closePopupOnClick: false,
                dragging: false,
                zoomSnap: false,
                zoomDelta: false,
                trackResize: false,
                touchZoom: false,
                scrollWheelZoom: false,
                zoom: this.zoom,
            },
        });
        this.mapService.setLayers({
            markerLayer: {
                id: 'markerLayer',
                type: 'marker',
                hasPopup: false,
                zIndex: 500,
                isInteractive: false,
                objects: [
                    {
                        id: 'marker',
                        geometry: this.geometry,
                    },
                ],
                icon: {
                    type: 'svgTpl',
                    default: {
                        ...this.icon,
                    },
                },
            },
        });
    }
}
